import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';

import request from '../../../../../utils/request';
import TypeAhead from '../../../../../orderDetails/components/typeAhead';

import { useLocalizedStringsContext } from '../../../../../context/LocalizedStringsContext';

const FilterBySalesRep = ({ filters, setFilters }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    ORDERS: { filterBySalesRep, salesRepNamePlaceholder }
  } = localizedStrings;
  const [salesRepNames, setSalesRepNames] = useState();

  useEffect(() => {
    const getSalesReps = async () => {
      const result = await request.get('/salesRepUsers');
      if (result) {
        const transformedResult = _.get(result, 'data', []).map(item => ({
          label: item.name,
          id: item.id
        }));
        setSalesRepNames(transformedResult);
      }
    };
    getSalesReps();
  }, []);

  return (
    <div style={{ margin: '1rem 2rem', gridArea: 'f-salesRep' }}>
      <TypeAhead
        label={filterBySalesRep}
        placeholder={salesRepNamePlaceholder}
        options={salesRepNames}
        selected={filters.createdBy}
        onChange={value => setFilters({ ...filters, createdBy: value })}
      />
    </div>
  );
};

FilterBySalesRep.propTypes = {
  filters: PropTypes.objectOf(PropTypes.shape({})).isRequired,
  setFilters: PropTypes.func.isRequired
};

export default FilterBySalesRep;
